export default __webpack_public_path__ + "static/media/RpiPlantWateringSystemDiagram.92f9226a.jpg";